import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
	faChevronCircleLeft,
	faChevronCircleRight,
	faCopy,
	faDolly,
	faDownload,
	faEdit, faEnvelope,
	faEye,
	faFileAlt,
	faFileExcel,
	faFilePdf,
	faFileUpload,
	faFillDrip,
	faImages,
	faLock,
	faLockOpen,
	faPlusCircle,
	faSave,
	faSort,
	faSortDown,
	faSortUp,
	faTag,
	faTimes,
	faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import vueHeadful from 'vue-headful';
import VueElementLoading from 'vue-element-loading'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './filters/filter.js'
import vClickOutside from 'v-click-outside'
import IdleVue from "idle-vue";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';


require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('select2/dist/css/select2.css');

library.add(faEye);
library.add(faSave);
library.add(faTimes);
library.add(faEdit);
library.add(faLock);
library.add(faDownload);
library.add(faLockOpen);
library.add(faFileAlt);
library.add(faPlusCircle);
library.add(faTimesCircle);
library.add(faCopy);
library.add(faSort);
library.add(faSortUp);
library.add(faSortDown);
library.add(faFileExcel);
library.add(faFilePdf);
library.add(faFileUpload);
library.add(faTag);
library.add(faImages);
library.add(faChevronCircleRight);
library.add(faChevronCircleLeft);
library.add(faFillDrip);
library.add(faDolly);
library.add(faEnvelope);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-headful', vueHeadful);
Vue.component('VueElementLoading', VueElementLoading);

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(vClickOutside);

Vue.config.productionTip = false;

/*axios.interceptors.response.use(value => {
	return value;
}, error => {
	console.log('Interceptor error...')
	console.log(JSON.stringify(error))
	return Promise.reject(error)
})*/

const eventsHub = new Vue();

Vue.component('v-select', vSelect)

Vue.use(IdleVue, {
	eventEmitter: eventsHub,
	store,
	idleTime: 300000, // 3 seconds
	startAtIdle: false
});

new Vue({
	router,
	store,
	render: function (h) {
		return h(App)
	}
}).$mount('#app');